import { createRoutine } from 'redux-saga-routines';

// Routines
export const fetchAssessments = createRoutine('assessment/FETCH_ASSESSMENTS');
export const fetchCategories = createRoutine('assessment/FETCH_CATEGORIES');
export const fetchSubjects = createRoutine('assessment/FETCH_SUBJECTS');
export const fetchGroupedAssignments = createRoutine(
  'assessment/FETCH_GROUPED_ASSIGNMENTS',
);

// Standard Actions Types
export const RESET_ASSESSMENT_STATE = 'RESET_ASSESSMENT_STATE';
export const ADD_QUESTION_TO_STATE = 'ADD_QUESTION_TO_STATE';
export const ADD_QUESTIONS_LIST_TO_STATE = 'ADD_QUESTIONS_LIST_TO_STATE';
export const REMOVE_NEW_ITEM_FROM_STATE = 'REMOVE_NEW_ITEM_FROM_STATE';

// Standard Action Creators
export const resetAssessmentState = () => ({
  type: RESET_ASSESSMENT_STATE,
});

export const addQuestion = (payload) => ({
  type: ADD_QUESTION_TO_STATE,
  payload,
});

export const addQuestions = (payload, showNewItem = false) => ({
  type: ADD_QUESTIONS_LIST_TO_STATE,
  payload,
  showNewItem,
});

export const removeNewQuestion = () => ({
  type: REMOVE_NEW_ITEM_FROM_STATE,
});
